import { AuthPluginClientOptions } from '@blitzjs/auth'

export const authConfig: AuthPluginClientOptions = {
  cookiePrefix: 'atlas',
}
